'use strict'

angular.module('rmBroadcast')
    .factory('Broadcast', require('./broadcast'))
